import { apiServerRoutes } from '../constants/apiRoutes'
import {
  deleteAPICallServer,
  getAPICallServer,
  postAPICallServer,
  putAPICallServer,
} from '../utils/axios.util'

class CartService {
  addItem(req: any) {
    return postAPICallServer(apiServerRoutes.ADD_ITEM_TO_CART, req.body, req)
  }

  fetch(req: any) {
    const { query } = req.body
    return getAPICallServer(
      `${apiServerRoutes.FETCH_CART}${query ? `?${query}` : ``}`,
      req,
    )
  }

  updateItem(req: any) {
    const { id, delivery_type } = req.body
    return postAPICallServer(
      apiServerRoutes.UPDATE_CART_ITEM.replace(':id', id),
      { delivery_type },
      req,
    )
  }

  remove(req: any) {
    const { id } = req.body
    return deleteAPICallServer(
      apiServerRoutes.REMOVE_CART_ITEM.replace(':id', id),
      req,
    )
  }

  updateDelvType(req: any) {
    return putAPICallServer(
      `${apiServerRoutes.UPDATE_DELV_TYPE}`,
      req.body,
      req,
    )
  }
}

export default new CartService()
